<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente-negoce/commande-client/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <app-tab-count [count]="getStatusCount('Tous')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente-negoce/commande-client/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <app-tab-count [count]="getStatusCount('Brouillon')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente-negoce/commande-client/valide']" [class.active]="currentStatus === 'valide'" (click)="filterByStatus('valide')">
                    Valide <app-tab-count [count]="getStatusCount('Valide')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente-negoce/commande-client/cree']" [class.active]="currentStatus === 'cree'" (click)="filterByStatus('cree')">
                    Créé <app-tab-count [count]="getStatusCount('Crée')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente-negoce/commande-client/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <app-tab-count [count]="getStatusCount('Annulé')"></app-tab-count>
                </a>
            </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>
